// Display serif for the landing headlines, served by Google Fonts (see LANDING_FONTS_URL); body
// text keeps the app's system font. The Vietnamese subset carries the stacked diacritics (ế, ộ, ữ).
export const DISPLAY_FONT = "'Fraunces', Georgia, 'Times New Roman', serif";

export const LANDING_FONTS_URL = 'https://fonts.googleapis.com/css2?family=Fraunces:wght@500;600&display=swap';
